
import * as React from 'react';
import { connect } from 'react-redux';
import { ICommission } from '../../../../data/entities/commission';
import { customerIsLegacyCommission } from '../../../../data/entities/commission/selectors';
import { actions } from '../../../../data/store';

import { currentUserId } from '../../../../entities/auth/session/selectors';
import { IChannel } from '../../../../entities/contracts/types';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { changeMarketingPreferencesActions as marPrefActions, getMarketingPreferences, updateMarketingPreferences as updateMarPrefs } from '../actions';
import { MarketingPreferencesComponent } from './marketingHub';
import { ISaveState } from './reducers';
import { IMarketingPreferences } from './types';

interface IMarketingHubContainerProps {
	customerId: string;
	marketingPreferences: IMarketingPreferences;
	commissions: ICommission;
	channels: IChannel[];
	loading: boolean;
	saving: boolean;
	saveState: ISaveState;
	touched: boolean;
	isLegacyCommission: boolean;
	getMarketingPreferences(customerId: string): any;
	getCustomerCommissions(customerId: string): any;
	onSubmit(customerId: string, marketingPreferences: IMarketingPreferences): any;
	onChange(id: string, marketingPreferences: IMarketingPreferences): any;
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getMarketingPreferences: (customerId: string) => dispatch(getMarketingPreferences(customerId)),
	getCustomerCommissions: (customerId: string) => dispatch(actions.commission.getByCustomer(customerId)),
	onSubmit: (customerId: string, marketingPreferences: IMarketingPreferences) =>
		dispatch(updateMarPrefs(customerId, marketingPreferences)),
	onChange: (id: string, marketingPreferences: IMarketingPreferences) => dispatch(marPrefActions.UI_CHANGED({ id, marketingPreferences }))
});

const mapStateToProps = (state: IState) => {
	const customerId = currentUserId(state);
	const marketingPreferences = state.views.marketing.home.drafts[customerId] || {};
	const commissions = state.data.commission.byCustomer[customerId];
	const isLegacyCommission = customerIsLegacyCommission(state, customerId);
	const { defaultChannels } = state.entities.channels;
	const { loading, saving, saveState, touched } = state.views.marketing.home;

	return {
		marketingPreferences,
		commissions,
		isLegacyCommission,
		customerId,
		loading,
		saving,
		saveState,
		touched,
		channels: defaultChannels
	};
};

class MarkertingPreferencesContainer extends React.Component<IMarketingHubContainerProps> {
	public async componentWillMount() {
		const { contracts, cancellationPolicy } = this.props.marketingPreferences;
		if (!contracts || !cancellationPolicy) {
			await this.props.getMarketingPreferences(this.props.customerId);
		}
		if (!this.props.commissions) {
			await this.props.getCustomerCommissions(this.props.customerId);
		}
	}

	public render() {
		const { customerId,
			loading, touched, saving, saveState,
			marketingPreferences: statePreferences,
			commissions,
			channels,
			isLegacyCommission,
			onSubmit,
			onChange,
		} = this.props;
		// Copy the data to avoid mutating state (delete calls below)
		const marketingPreferences = { ...statePreferences, contracts: { ...statePreferences.contracts } };

		return <MarketingPreferencesComponent
			customerId={customerId}
			marketingPreferences={marketingPreferences}
			commissions={commissions}
			channels={channels}
			loading={loading}
			saving={saving}
			saveState={saveState}
			touched={touched}
			isLegacyCommission={isLegacyCommission}
			onSubmit={onSubmit}
			onChange={onChange}
		/>;
	}

}

export const MarketingPreferences = connect(mapStateToProps, mapDispatchToProps)(MarkertingPreferencesContainer);
